// eslint-disable-next-line no-restricted-imports

import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { spaces } from '@99designs/emu/settings';

interface Props {
    title: string;
    textAlignment?: 'left' | 'center' | 'right';
    children: React.ReactNode;
}

const StyledHeader = styled.div<Pick<Props, 'textAlignment'>>`
    text-align: ${(props) => props.textAlignment};
    position: relative;
    padding-top: ${spaces['2bu']};
    padding-bottom: ${spaces['2bu']};
`;

function Header({ children, title, textAlignment = 'left' }: Props) {
    return (
        <>
            <Helmet
                title={title}
                bodyAttributes={{
                    class: 'max--desktop',
                }}
            />
            <StyledHeader textAlignment={textAlignment}>{children}</StyledHeader>
        </>
    );
}

export default Header;
